module.exports = __webpack_public_path__ + "static/media/295222.30be014d.png";